import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countdown"]

  connect() {
    if (this.hasCountdownTarget === false) {
      return
    }

    this._updateCountdown()
  }

  _updateCountdown() {
    var _this = this

    if (App.readCookie("phone_verification_sent_at") == null) {
      App.createCookie("phone_verification_sent_at", new Date(), 1)
    }

    setInterval(function countdownCheck() {
      var phoneVerificationSentAt = new Date(App.readCookie("phone_verification_sent_at"))
      var remainingSeconds = Math.round(300 - ((new Date() - phoneVerificationSentAt) / 1000))

      if (remainingSeconds <= 0) {
        location.reload()
        return
      }

      _this.countdownTarget.innerHTML = i18n.t("js.front.validate_phone_number.step2.countdown", { seconds: remainingSeconds})

      return countdownCheck
    }(), 1000)
  }

  back() {
    App.eraseCookie("phone_verification_sent_at")

    Turbo.visit("/validation/phone-number/step_1")
  }
}
